import {dialogTriggerClickHandler} from './base';
import {lockButton, unlockButton} from '../form-utils/base';
import {api} from '../api';
import {showAlert} from '../form-utils/alert';

const clearSubmitHandler = (evt) => {
    const confirmElement = evt.target.closest('#clearConfirm');

    const submitButton = evt.currentTarget;

    lockButton(submitButton);

    api.delete(`favorite/`)
        .json()
        .then((response) => {
            showAlert(confirmElement, 'beforebegin', response.message, 'success');
            setTimeout(() => {
                document.location.reload();
            }, 500);
        })
        .catch(async (error) => {
            const errorJson = await error.response.json();

            showAlert(confirmElement, 'beforebegin', errorJson.message, 'error');

            unlockButton(submitButton);
        });
};

const clearSubmitDialogInit = (dialogElement) => {
    const btn = dialogElement.querySelector('#clearFavoritesBtn');

    if (btn) {
        btn.addEventListener('click', clearSubmitHandler);
    }
};

const displaysDialogInit = (dialogElement) => {
    const triggerElements = document.querySelectorAll('.clear-favorites-dialog-trigger');

    if (triggerElements.length > 0) {
        triggerElements.forEach((triggerElement) => {
            triggerElement.addEventListener('click', (evt) => {
                dialogTriggerClickHandler(evt, dialogElement);
            });
        });
    }
};

const clearFavoritesDialogInit = () => {
    const dialogElement = document.querySelector('#clearFavorites');

    if (dialogElement) {
        displaysDialogInit(dialogElement);
        clearSubmitDialogInit(dialogElement);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    clearFavoritesDialogInit();
});
